// extracted by mini-css-extract-plugin
export var carrierIcon = "_xs-0";
export var carrierLogo = "_xs-1";
export var detailsSection = "_xs-2";